var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 957 957",
    className: "logo",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\r\n    Dealership Advantage\r\n  ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "main",
    d: "M238.5 680.4v-489H547.6c153.4 0 256.4 148.8 257.4 286.6C806.3 652.5 702 765.5 547.6 765.5H252.9L432.1 304h66.8l133.1 311-61 37L466.5 414.8 357.6 695.4H564.9C667 695 733 597 733 478c0-123-90-214-185.4-214h-237V494.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "outline",
    d: "M478.5 0C214.2 0 0 214.2 0 478.5S214.2 957 478.5 957 957 742.8 957 478.5 742.8 0 478.5 0Zm0 892C251.2 892 67 707.8 67 480.5S251.2 69 478.5 69 890 253.2 890 480.5 705.8 892 478.5 892Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c763d24.svg";
export { ForwardRef as ReactComponent };